import Viewer from "./Viewer";

function App() {
  return <Viewer />;
}

export default App;
